import { render, staticRenderFns } from "./ExhibitionMenu.vue?vue&type=template&id=4b08b3ec&"
import script from "./ExhibitionMenu.vue?vue&type=script&lang=js&"
export * from "./ExhibitionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports